import { render } from "./AsideMenu.vue?vue&type=template&id=44aebc7e&scoped=true&bindings={\"handleBtnClick\":\"setup\",\"activeDevice\":\"setup\"}"
import script from "./AsideMenu.vue?vue&type=script&lang=js"
export * from "./AsideMenu.vue?vue&type=script&lang=js"

import "./AsideMenu.vue?vue&type=style&index=0&id=44aebc7e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-44aebc7e"

export default script